var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBenefits08(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 60,
    viewBox: "0 0 77 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5595 51.7242C18.4631 47.3949 14.4824 40.2571 14.4824 32.1851C14.4824 18.9804 25.135 8.27588 38.2755 8.27588C51.4161 8.27588 62.0686 18.9804 62.0686 32.1851C62.0686 40.9767 57.9064 47.5705 50.8719 51.7242M50.8719 51.7242L59.8293 50.1873M50.8719 51.7242L54.5108 44.2803",
    stroke: "#00583E",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8689 35.1863H34.7171V32.3587H42.8689V35.1863ZM38.3723 23.8207H39.2275L33.5171 40H30.3447L37.2275 20.6897H40.3585L47.2551 40H44.0689L38.3723 23.8207Z",
    fill: "#00583E"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBenefits08);
export default __webpack_public_path__ + "static/media/benefits_08.30799f2dc2836be01f77f4bab0d8d1c0.svg";
export { ForwardRef as ReactComponent };